// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
// import PropTypes from "prop-types";

// Internal Imports
import { DOCUMENT_ROLES, DOCUMENT_STAGES } from "./Constants";
import { DOCUMENT_BTNS } from "./Configuration/Components";
import { GlobalUtils } from "../../utils";

// Destructuring
const { readDataFromLocalStorage } = GlobalUtils;

class QuotationTopBarV3 extends Component {
  state = {};

  _getUserRole = () => {
    const user = readDataFromLocalStorage("revvsalesUser");
    const { docOwnerID, hasDocWriteAccess } = this.props;

    const userRole = user.roles[0].name;
    const isOrgAdmin = userRole === "Admin";
    const isDocOwner = docOwnerID === user.id;

    if (isOrgAdmin || isDocOwner || hasDocWriteAccess) {
      return "ADMIN";
    }
    return "USER";
  };

  render() {
    const { documentStage } = this.props;
    const userRole = this._getUserRole();

    const COMPONENTS =
      DOCUMENT_BTNS[DOCUMENT_STAGES[documentStage]][DOCUMENT_ROLES[userRole]];

    return (
      <div className="quotationtopbarv3-wrapper">
        {COMPONENTS &&
          COMPONENTS.length > 0 &&
          COMPONENTS.map(btn =>
            React.createElement(btn.component, { key: btn.name, ...btn.props }),
          )}
      </div>
    );
  }
}

QuotationTopBarV3.defaultProps = {};

QuotationTopBarV3.propTypes = {};

const mapStateToProps = state => {
  // Store Imports
  const {
    document: {
      created_by: { id: docOwnerID },
      scope: { write: hasDocWriteAccess },
      stage: documentStage,
    } = {},
  } = state.DocumentStore;

  // Export as props
  return { documentStage, docOwnerID, hasDocWriteAccess };
};

export default connect(mapStateToProps)(QuotationTopBarV3);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/QuotationTopBarV3.js